import {DigitalRevisionMenuItem} from '../interfaces/digital-revision-menu-item';
import {ProxyTypeEnum} from '../interfaces/proxy-type-enum';
import {MenuItemTypeEnum} from '../interfaces/menu-item-type-enum';
import { MenuItemModel } from '../models/menu-item.model';

const sharedMenuBar: MenuItemModel[] = [
  {
    Text: 'Home',
    ImagePath: '/assets/images/landing/home.png',
    DestinationPage: '',
  },
  {
    Text: 'Quick Quiz',
    ImagePath: '/assets/images/landing/quick-quizzes.png',
    DestinationPage: 'Quick-Quiz',
  },
  {
    Text: 'Exam Skills Videos',
    ImagePath: '/assets/images/landing/exam-skills-videos.png',
    DestinationPage: 'Videos',
  },
  {
    Text: 'Summary Test',
    ImagePath: '/assets/images/landing/revision-summary-test.png',
    DestinationPage: 'Revision-Summary-Test',
  },
  {
    Text: 'Timeline',
    ImagePath: '/assets/images/landing/timelines-icon.png',
    DestinationPage: 'timeline',
  }
];

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.QuickQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a Quick Quiz',
    ButtonURL: 'quick-quiz',

    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/HEANO43/HEANO43_QuickQuiz_v1',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],
    HasData: true,
    HeadingText: 'Quick Quizzes',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Test yourself with quizzes covering every topic. On your marks, get set... quiz!</p>' +
      '\n' +
      '<p>Questions answered: <strong>[[variable1]]</strong></p>\n' +
      '\n' +
      '<p>Last quiz score: <strong>[[variable2]]</strong></p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Questions on every topic',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.MistakesQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#F0542C',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Mistakes Quiz',
    ButtonURL: 'mistakes-quiz',

    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/HEANO43/HEANO43_Mistakes_v1',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],
    HasData: true,
    HeadingText: 'Your Mistakes Quiz',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>The quick quiz questions you got wrong are here — have another go and conquer them once and for all!</p>' +
      '<p>Total questions stored: <strong>[[variable1]]</strong></p>\n' +
      '<p>Total questions answered: <strong>[[variable2]]</strong><br />\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Correct your wrong answers',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.RevisionSummary,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Revision Summary Tests',
    ButtonURL: 'revision-summary-test',

    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/HEANO43/HEANO43_RevSum_v1',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],
    HasData: true,
    HeadingText: 'Revision Summary Test',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>See how well you understand each section. Mark your answers with our examples.</p>' +
      '<p>Questions answered: <strong>[[variable1]]</strong></p>\n' +
      '<p>Questions marked <img src="assets/images/smiley-face-green.png" width="30" height="30" style="vertical-align:middle;" /> : <strong>[[variable2]]</strong><br />\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'In-depth written questions',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.Answers,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Answers',
    ButtonURL: 'answers',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Answers',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>You can find all your Revision Summary Test answers here.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Printable answer sheets',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      // TODO: populate ContentMain with intro text and ContentRight with an image if needed
      // TODO: verify the PDF links work for this product after the cloudfront changes from David
      HeaderText: 'Answers',
      ContentMain: '<div class="free-content">' +
        '<p>Your printable Revision Summary Test answers are all below. Take your pick!</p>' +
        '<strong>' + 
        '<a href="[[cloudfront_url]]/_revisionhub_opc/HEANO43/PDFs/cgp-gcse-edexcel-history-summaryanswers-normans-anglosaxonengland.pdf"><span style="color:#1494d4;">Anglo‑Saxon England and the Norman Conquest, 1060‑1066</span></a><br />' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/HEANO43/PDFs/cgp-gcse-edexcel-history-summaryanswers-normans-securingthekingdom.pdf"><span style="color:#1494d4;">William I in Power: Securing the Kingdom, 1066‑1087</span></a><br />' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/HEANO43/PDFs/cgp-gcse-edexcel-history-summaryanswers-normans-normanengland.pdf"><span style="color:#1494d4;">Norman England, 1066‑1088</span></a>' +
        '</strong>' +
        '</div>' ,
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.Timeline,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Timeline',
    ButtonURL: 'timeline',

    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/HEANO43/HEANO43_Timeline_v1',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],
    HasData: false,
    HeadingText: 'Timelines',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>All the key events for this topic laid out for you. Expand them to see more detail — super handy!</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'See the key events for this topic',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.ExamSkillsVideos,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Watch videos',
    ButtonURL: 'videos',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Exam Skills Videos',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Our experts talk you through how to answer each different question type in the exams.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Learn how to write a top answer',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Exam Skills Videos',
        Intro: '<p>GCSE History exam questions can be quite a lot to chew on. Thankfully, our experts will show you how to write a top answer for some key question types in these step-by-step videos!</p>',
        LeftSections: [
          {
            Header: 'All Questions',
            Subcategories: [
              { Name: 'Question 2 - Explain Why', ShortName: 'explain-why', Link: '%cgpbooks%/revision-hub/heano42/exam-skills-videos/explain-why' },
              { Name: 'Questions 3 & 4 - Planning an Essay', ShortName: 'planning-an-essay-answer', Link: '%cgpbooks%/revision-hub/heano42/exam-skills-videos/planning-an-essay' },
            ],
          },
        ],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.OnlineEdition,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Online Products',
    ButtonURL: '[[external_domain]]/bookspacedemo',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Online Edition',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Use your book wherever you are with your Online Edition — yippee!</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Read your e-Book here',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.NeedHelp,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: '',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Need some help?',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Take a look at the FAQs if you need some help.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Check out our FAQS',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text:
        '<h2>Frequently Asked Questions</h2>\n' +
      '<h5>What is CGP RevisionHub?</h5>\n' +
      '<p>Great question! CGP RevisionHub is our online platform where you can find lots of helpful revision, all matched to your GCSE History books. Use the quizzes, flashcards and more to revise what you\'ve learned from your book and prepare for the exams.</p>\n' +
      '<h5>How do I access CGP RevisionHub?</h5>\n' +
      '<p>You can access CGP RevisionHub on your computer, tablet or phone. Just make sure your device can connect to the internet. Wearing a spinny propellor hat is not required, but it is cool though.</p>\n' +
      '<h5>How do I use CGP RevisionHub with my book?</h5>\n' +
      '<p>You\'ll notice lots of QR codes scattered throughout your book. Give them a scan and you\'ll automatically be taken to the relevant test, video or other revision thingy-ma-jig so you can go over what you\'ve learned!</p>\n' +
      '<h5>My CGP RevisionHub isn\'t working — what do I do?</h5>\n' +
      '<p>If you can\'t find the answer in these FAQs, it\'s time to contact our friendly Customer Services team. You could also ask your friendly neighbourhood psychic, but they will charge...</p>\n' +
      '<h5>Do I need an internet connection to use CGP RevisionHub?</h5>\n' +
      '<p>Yes, you do. But you can also download some handy PDF resources to use offline. Nice.</p>\n' +
      '<h5>If I log in on a different device, will all my progress be saved?</h5>\n' +
      '<p>Yep. Just log in on your computer, tablet or phone, and all your progress will be there waiting for you.</p>\n' +
      '<h5>What\'s the difference between the Quick Quizzes, Your Mistakes Quiz and Revision Summary Tests?</h5>\n' +
      '<p>Quick Quizzes are... well, quick! They\'re a speedy way to test all the facts on the course. Your Mistakes Quiz tests you on all the questions you got wrong in your Quick Quizzes. Revision Summary Tests include more challenging questions — mark them yourself using our example answers.</p>\n' +
      '<h5>Can I clear my progress so far in CGP RevisionHub and start again?</h5>\n' +
      '<p>There are no takie-backsies in CGP RevisionHub, so you can\'t clear your results and start again. But, you can have another go at any of the quizzes and they\'ll update to show your latest scores. Keep going, we believe in you!</p>\n' +
      '<h5>Can I share my test results with other people?</h5>\n' +
      '<p>You can\'t share results directly via CGP RevisionHub, but there are other means… Carrier pigeons and smoke signals are both great options. Or you could just tell them, but where\'s the fun in that?</p>\n' +
      '<h5>What happens when I\'ve answered all the questions?</h5>\n' +
      '<p>Ah, one of life\'s greatest questions — what next? We\'d recommend that you keep practising right up until your exams.</p>\n' +
      '<h5>Will I always have access to CGP RevisionHub?</h5>\n' +
      '<p>Once you activate the code in the front of your book, you\'ll have access for three years. And they\'ll be three whole years of bliss, we promise.</p>\n',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP Revision',
    ButtonURL: '[[external_domain]]/secondary-books/gcse',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>There\'s plenty more revision where this came from! Take a look at some of our other revision books.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },}
];